import * as Yup from "yup";
// Step2-5 (Observations 1-4) are no longer driven by these static arrays —
// see NMPClassificationStep.tsx (reused as-is) / getSchemeClassificationTree
// instead, exactly like NMP. Kept for CMBFSSchemaStep2-5 below, which are
// commented out but not deleted, per this project's established convention.
// import {
// 	step2Questions,
// 	step3Questions,
// 	step4Questions,
// 	step5Questions,
// } from "./CMBFSQuestions";

export const CMBFSSchemaStep1 = Yup.object().shape({
	district_id: Yup.number().required("District is required"),
	udise_code: Yup.string().required("UDISE Code is required"),
	school_name: Yup.string().required("School Name is required"),

	// Text, not a number: audit_calendars.round_no can hold non-numeric pilot
	// labels (e.g. "Pilot 2"), not just plain round numbers.
	round_no: Yup.string().required("Round No is required"),
	audit_start_date: Yup.string().required("Audit Start Date is required"),
	audit_end_date: Yup.string().required("Audit End Date is required"),
	sgs_date: Yup.string().required("Gram Sabha Date is required"),
	audit_year_id: Yup.number().required("Audit Year is required"),

	overall_quality_food: Yup.string().required("Breakfast quality is required"),

	avg_current_year_children_prepared: Yup.number().required("Required").min(0),
	avg_current_year_children_consumed: Yup.number().required("Required").min(0),
	avg_current_year_rice_cooked: Yup.number().required("Required").min(0),

	avg_audit_period_children_prepared: Yup.number().required("Required").min(0),
	avg_audit_period_children_consumed: Yup.number().required("Required").min(0),
	avg_audit_period_rice_cooked: Yup.number().required("Required").min(0),
});

// CMBFSSchemaStep2-5 superseded by the dynamic classification-tree schema
// built in CMBFSSchemeStepper.tsx (see NMPSchemeStepper.tsx's
// generateClassificationSchema, reused as-is). Commented out, not deleted,
// per this project's established convention.
// export const CMBFSSchemaStep2 = Yup.object().shape({
// 	...generateYupShape(step2Questions),
// });

// export const CMBFSSchemaStep3 = Yup.object().shape({
// 	...generateYupShape(step3Questions),
// });

// export const CMBFSSchemaStep4 = Yup.object().shape({
// 	...generateYupShape(step4Questions),
// });

// export const CMBFSSchemaStep5 = Yup.object().shape({
// 	...generateYupShape(step5Questions),
// });

export const CMBFSSchemaStep6 = Yup.object().shape({
	unique_aspects: Yup.string().required("Unique aspects is required"),
	committee_remarks: Yup.string().required("Committee remarks is required"),
	changes_due_to_audit: Yup.string().required("Required"),
	changes_due_to_audit_paragraph: Yup.string().when("changes_due_to_audit", {
		is: "yes",
		then: (schema) => schema.required("Please describe the changes"),
	}),
	photo_1: Yup.mixed().required("Photo 1 is compulsory"),
	report_file: Yup.mixed().required("Audit Report is required"),
});

export const initialCMBFSValues = {
	// Step 1
	district_id: "",
	udise_code: "",
	school_name: "",
	round_no: "",
	audit_start_date: "",
	audit_end_date: "",
	sgs_date: "",
	audit_year_id: "",
	drp_employee_code: "",
	drp_name: "",
	drp_mobile_no: "",
	drp_district_id: null,
	drp_block_id: null,
	vrp_details: [{ mobile_no: "", name: "", village_id: "" }],
	overall_quality_food: "",

	avg_current_year_children_prepared: 0,
	avg_current_year_children_consumed: 0,
	avg_current_year_rice_cooked: 0,

	avg_audit_period_children_prepared: 0,
	avg_audit_period_children_consumed: 0,
	avg_audit_period_rice_cooked: 0,

	// Step 6 fields (Observations 5)
	unique_aspects: "",
	committee_remarks: "",
	changes_due_to_audit: "no",
	changes_due_to_audit_paragraph: "",
	case_study_1_type: "",
	case_study_1_file: null,
	case_study_2_type: "",
	case_study_2_file: null,
	photo_1: null,
	photo_2: null,
	photo_3: null,
	report_file: null,

	// Step2-5 (Observations 1-4) initial values are no longer static — see
	// NMPClassificationStep.tsx's field-naming convention (subcat_<id>),
	// merged in by CMBFSSchemeStepper.tsx once the classification tree has
	// loaded, exactly like NMP.
	// ...generateInitialValues(step2Questions),
	// ...generateInitialValues(step3Questions),
	// ...generateInitialValues(step4Questions),
	// ...generateInitialValues(step5Questions),
};
